<template>
  <div class="content">
    <h1>
      <breadcrumbs :value="record" />
    </h1>

    <div v-if="record === null && loadingCount > 0">
      Loading..
    </div>
    <div v-else-if="record === null">
      No record available
    </div>
    <div v-else class="flex flex-col gap-4">
      <div class="flex flex-col md:flex-row justify-between">
        <div class="flex gap-2 items-center">
          <div>Changes are saved automatically.</div>
          <b-spinner v-if="isSaving" label="Spinning" small></b-spinner>
        </div>
        <action-buttons
          :value="record"
          @printLink="printLink"
          @delete="deleteRecord"
        />
      </div>
      <div class="max-w-lg">
        <h2 class="text-lg font-bold">
          Details
        </h2>
        <record-details v-model="record" />
      </div>
      <div>
        <h2 class="text-lg font-bold">
          Main photos
        </h2>
        <record-files :id="competitorId" fileSource="record" />
      </div>

      <div>
        <h2 class="text-lg font-bold">
          Burn Test
        </h2>
        <record-files :id="competitorId" fileSource="burn_test" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getLabelPrinter,
} from '@/helpers';

const _ = require('lodash');

const Breadcrumbs = () => import('@/components/competitor/Breadcrumbs.vue');
const ActionButtons = () => import('@/components/competitor/ActionButtons.vue');
const RecordDetails = () => import('@/components/competitor/RecordDetails.vue');
const RecordFiles = () => import('@/components/competitor/RecordFiles.vue');

export default {
  name: 'Competitor',
  components: {
    Breadcrumbs,
    ActionButtons,
    RecordDetails,
    RecordFiles,
  },
  computed: {
    competitorId() {
      return parseInt(this.$route.params.id, 10);
    },
    isSaving() {
      return this.savingCount > 0;
    },
  },
  data() {
    return {
      loadingCount: 0,
      savingCount: 0,
      record: null,
      modals: {},
      scheduleUpdate: _.debounce(() => {
        this.updateRecord();
      }, 250),
    };
  },
  methods: {
    fetchRecord() {
      this.loadingCount++;
      this.$http
        .get(`/competitors/${this.competitorId}`)
        .then((res) => {
          this.record = res.body;
        })
        .catch((err) => {
          this.$toast.error(`Failed to fetch candle: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    updateRecord() {
      this.savingCount++;
      this.$http
        .put(`/competitors/${this.competitorId}`)
        .send({ changes: this.record })
        .then(() => {
          // no-op
        })
        .catch((err) => {
          this.$toast.error(`Failed to update record: ${err.response.text}`);
        })
        .finally(() => {
          this.savingCount--;
        });
    },
    deleteRecord() {
      if (!confirm('Do you really wish to delete this record?')) {
        return;
      }
      this.loadingCount++;
      this.$http
        .delete(`/competitors/${this.competitorId}`)
        .then(() => {
          this.$router.push('/competitors');
        })
        .catch((err) => {
          this.$toast.error(`Failed to delete record: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    printLink() {
      this.loadingCount++;
      this.$http
        .post(`/competitors/${this.competitorId}/print_link`)
        .send({ printer_id: getLabelPrinter() })
        .send({ amount: 1 })
        .then(() => {
          this.$toast.success('Printed');
        })
        .catch((err) => {
          this.$toast.error(`Failed to print: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
  },
  created() {
    this.fetchRecord();
  },
  watch: {
    record: {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal === null) {
          return;
        }
        this.scheduleUpdate();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
